import '../scss/pumpDumpPage.scss';

import menuModule from "./modules/menu.js";
import faqModule from "./modules/faqModule.js";
import scrollUpModule from "./modules/scrollUpModule.js";
import footerModule from "./modules/footerModule.js";
import terminDescModule from "./modules/terminDescModule.js";

(function ($) {
    $(document).ready(function () {
        window.$ = jQuery;

        menuModule.init();
        faqModule.init();
        scrollUpModule.init();
        footerModule.init();
        terminDescModule.init();

        ////////// Фильтры //////////

        const toggleBtn = $('#filter-toggle-btn');
        const filterForm = $('#rating-filter-form');
        const tagsBlock = $('#rating-filter-selected-tags');

        toggleBtn.click(() => {
            filterForm.toggle()
        })


        // Открытие закрытие фильтра
        $('.rating-filter-inputs-item').on('click', '[data-filter-toggle]', function (e) {
            e.preventDefault();

            const $item = $(this).closest('.rating-filter-inputs-item');

            // Закрываем все, кроме текущего
            $('.rating-filter-inputs-item').not($item).removeClass('open');

            // Переключаем текущий
            $item.toggleClass('open');
        });

        // Закрываем все выпадающие фильтры по клику вне
        $(document).click(function (e) {
            if (!$(e.target).closest('.rating-filter-inputs-item').length) {
                $('.rating-filter-inputs-item').removeClass('open')
            }

            if (!$(e.target).closest('.rating-sort-dropdown.open').length) {
                $('.rating-sort-dropdown.open').removeClass('open')
            }
        })

        // При кликах на чекбоксы
        $('.rating-filter-inputs-item-options').on('click', '.checkbox-item', function (e) {
            e.preventDefault();
            const input = $(e.target).closest('label').find('input')[0];
            const checked = $(input).prop('checked')

            $(input).prop('checked', !checked)

            onFormChanged();
        })

        // Удаление фильтра через выбранные теги
        tagsBlock.on('click', '[data-delete-rating-tag]', function (e) {
            const btn = $(e.target).closest('[data-delete-rating-tag]')[0];

            $(`[name="${btn.dataset.deleteRatingTag}"][value="${btn.dataset.deleteRatingTagValue}"]`).prop('checked', false);

            $(e.target).closest('.rating-filter-selected-tags-item')[0].remove();
            if (!$('.rating-filter-selected-tags-item').length) {
                $('#rating-filter-selected').removeClass('show')
            }

            onFormChanged();
        })

        function setPlaceHolders(formData) {
            const values = {};
            let value = '';

            for (let field in formData) {
                if (Array.isArray(formData[field])) {
                    value = formData[field].map(value => {
                        return window.pump[field][value].name;
                    }).join(', ')
                } else {
                    value = window.pump[field][formData[field]].name;
                }

                values[field] = value;
            }

            $('[data-placeholder]').each(function (i, item) {
                const {placeholder: field, placeholderDefault} = item.dataset;
                $(item).text(values[field] ? values[field] : placeholderDefault);
            });
        }

        function setTags() {
            const formData = filterForm.serializeArray();
            const tags = [];

            formData.forEach(function (item, itemKey) {
                item.name = item.name.replace('[]', '')

                tags.push(`
            <div class="rating-filter-selected-tags-item">
                ${window.pump[item.name][item.value].name}
                <svg data-delete-rating-tag="${item.name}" data-delete-rating-tag-value="${item.value}" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="20" height="20" rx="10" fill="#F5F7F8"/>
                    <rect x="6.71094" y="6" width="11" height="1" rx="0.5" transform="rotate(45 6.71094 6)" fill="#0457CA"/>
                    <rect x="6" y="13.7773" width="11" height="1" rx="0.5" transform="rotate(-45 6 13.7773)" fill="#0457CA"/>
                </svg>
            </div>
        `);
            })

            tagsBlock.html(tags.join(''));

            if (tags.join('')) {
                $('#rating-filter-selected').addClass('show');
            } else {
                $('#rating-filter-selected').removeClass('show')
            }
        }

        function getFormData() {
            const formData = filterForm.serializeArray();
            const data = {};

            formData.forEach(({name, value}) => {
                const input = $(`#rating-filter-form [name="${name}"]`)[0];
                const isArray = input.type === 'checkbox';

                if (data[name] === undefined) {
                    data[name] = isArray ? [value] : value;
                } else {
                    data[name].push(value);
                }
            });

            return data;
        }

        function onFormChanged() {
            setTags();

            const data = getFormData();

            setPlaceHolders(data);

            filteredNextColumn = 'left';

            if(isFilterActive(data)) {
                liveCardsBlock.css('height', 'auto');
                loadMoreBtn.hide();
            } else {
                liveCardsBlock.css('height', liveCardsBlockHeight + 'px');
                loadMoreBtn.show();
            }


            rerenderCards();
        }

        // Сброс значение формы
        $('#rating-filter-selected-reset').click(function (e) {
            $('#rating-filter-selected').removeClass('show')
            tagsBlock.html('');
            filterForm.trigger('reset');

            onFormChanged();
        })

        ////////// Карточки //////////

        let allCards = [];
        const loadMoreBtn = $('[data-load-more]');
        const liveCardsBlock = $('.live-cards')
        let liveCardsBlockHeight = 0;
        let page = loadMoreBtn.data('loadMore');


        loadMoreBtn.on('click', function (e) {
            e.preventDefault();

            if (!isFilterActive() && page < 5) {
                liveCardsBlockHeight = (liveCardsBlockHeight / page * (page + 1));

                liveCardsBlock.css('overflow-anchor', 'visible');
                liveCardsBlock.css('height', liveCardsBlockHeight + 'px');
                setTimeout(() => {
                    liveCardsBlock.css('overflow-anchor', 'none');
                }, 100)

                $(this).data('loadMore', page + 1)
                page += 1;

                if (+page >= 5) loadMoreBtn.hide();
            }
        })

        function cardMatchesFilters(cardOrData, filters = null) {
            const data = filters || getFormData();

            const selectedExchanges = Array.isArray(data.exchanges)
                ? data.exchanges.map(item => String(item).toLowerCase())
                : [];

            const pricesFilter = Array.isArray(data.prices)
                ? parseFloat(data.prices[0])
                : parseFloat(data.prices);
            const volumesFilter = parseFloat(data.volumes);

            let exchange;
            let prices;
            let volumes;

            if (cardOrData instanceof HTMLElement) {
                exchange = String(cardOrData.dataset.exchange || '').toLowerCase();
                prices = parseFloat(cardOrData.dataset.prices);
                volumes = parseFloat(cardOrData.dataset.volumes);
            } else {
                exchange = String(cardOrData.exchange || '').toLowerCase();
                prices = parseFloat(cardOrData.rel_price_deviation) * 100;
                volumes = parseFloat(cardOrData.volume_spike_multiplier);
            }

            if (!isNaN(pricesFilter) && (isNaN(prices) || Math.abs(prices) < pricesFilter)) {
                return false;
            }

            if (!isNaN(volumesFilter) && (isNaN(volumes) || volumes < volumesFilter)) {
                return false;
            }

            if (selectedExchanges.length >= 1) {
                return selectedExchanges.includes(exchange);
            }

            return true;
        }

        const leftCol = document.getElementById('live-col-left');
        const rightCol = document.getElementById('live-col-right');

        let nextColumn = 'left';
        let filteredNextColumn = 'left';

        function isMobile() {
            return window.innerWidth < 991;
        }

        function isFilterActive(data = null) {
            const formData = data || getFormData();
            return !!Object.keys(formData).length;
        }

        function getCardKey(item) {
            return [
                item.id || '',
                item.symbol || '',
                item.exchange || '',
                item.event || '',
                item.price || '',
                item.timestamp || ''
            ].join('|');
        }

        function upsertCard(item) {
            const key = getCardKey(item);
            const index = allCards.findIndex(card => getCardKey(card) === key);

            if (index === -1) {
                allCards.unshift(item);

                if (allCards.length > 100) {
                    allCards = allCards.slice(0, 100);
                }

                return {
                    isNew: true,
                    key
                };
            }

            allCards[index] = item;

            return {
                isNew: false,
                key
            };
        }

        function resetColumnsState() {
            nextColumn = 'left';
        }

        function clearCardsOnly() {
            leftCol.querySelectorAll('.live-card').forEach(card => card.remove());
            rightCol.querySelectorAll('.live-card').forEach(card => card.remove());
        }

        function trimColumnCards(column, maxCards = 50) {
            let cards = column.querySelectorAll('.live-card');

            while (cards.length > maxCards) {
                cards[cards.length - 1].remove();
                cards = column.querySelectorAll('.live-card');
            }
        }

        function trimAllColumns() {
            trimColumnCards(leftCol, 50);
            trimColumnCards(rightCol, 50);
        }

        function renderCardsFromData(items, newCardKey = null, startColumn = 'left') {
            clearCardsOnly();

            console.log('renderCardsFromData', items)

            let currentColumn = startColumn;

            items.forEach((item) => {
                const isNew = newCardKey && getCardKey(item) === newCardKey;
                const card = createCard(item, !!isNew, false);

                let targetCol;

                if (isMobile()) {
                    targetCol = leftCol;
                } else {
                    targetCol = currentColumn === 'left' ? leftCol : rightCol;
                    currentColumn = currentColumn === 'left' ? 'right' : 'left';
                }

                targetCol.append(card);
            });

            trimAllColumns();
        }

        function rerenderCards(newCardKey = null, startColumn = 'left') {
            const data = getFormData();

            if (isFilterActive(data)) {
                const filteredCards = allCards.filter(item => cardMatchesFilters(item, data));
                renderCardsFromData(filteredCards, newCardKey, startColumn);
            } else {
                renderCardsFromData(allCards, newCardKey, startColumn);
            }
        }

        function appendCard(item, isNew = false) {
            const card = createCard(item, isNew, false);
            const targetCol = getTargetColumn();

            targetCol.append(card);

            // if (isNew) {
            //     setTimeout(() => {
            //         card.classList.remove('is-new');
            //     }, 500);
            // }

            const cards = targetCol.querySelectorAll('.live-card');

            if (cards.length > 50) {
                const last = cards[cards.length - 1];
                last.remove();
            }

            return card;
        }

        function createCard(item, isNew = true, isReplacing = false) {

            const card = document.createElement('div');
            const data = getFormData();

            const dateObj = new Date(item.timestamp);
            const now = Date.now();

            const diffMs = now - dateObj.getTime();
            const isMoreThan2Min = diffMs >= 2 * 60 * 1000;

            const offset = -dateObj.getTimezoneOffset() / 60;
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            const date = dateObj.toLocaleTimeString('ru-RU', {
                timeZone,
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            }) + ` UTC${offset >= 0 ? '+' : ''}${offset}`;

            if (isReplacing) {
                card.className = `live-card replacing-card ${item.event}`  + (!isMoreThan2Min ? ' is-new' : '');
            } else {
                card.className = isNew ? `live-card is-new ${item.event}` : `live-card ${item.event}`;
            }

            card.dataset.exchange = item.exchange;
            card.dataset.prices = item.rel_price_deviation * 100;
            card.dataset.volumes = item.volume_spike_multiplier;
            card.dataset.timestamp = item.timestamp;

            // if (!cardMatchesFilters(item, data)) {
            //     card.style.display = 'none';
            // }

            // card.innerHTML = JSON.stringify(item);

            card.innerHTML = `
              <div class="live-card-section between w-100">
                    <div class="pair-block ">
                        <div class="ball "></div>
                        <div class="event">${item.event}</div>
                        <div class="pair">${item.symbol}</div>
                    </div>
                    <div class="exchange-block">
                        <a target="_blank" href="${item.buy_exchange_link}" onclick="yaCounter46008906.reachGoal('link_${item.exchange}');" target="_blank" rel="nofollow noopener noreferrer" class="exchange">${item.exchange}</a>
                        <div class="date">${date}</div>
                    </div>
                </div>
                <div class="live-card-section w-100">
                    <div class="pump-label w-100">${window.pump.words['pumpPrice']}</div>
                    <div class="price-block">
                        <span class="pump-value">${'$' + item.prev_price}</span>
                        <span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.95312 5.61963L12.3336 8.00014L9.95312 10.3807" stroke="#292D32" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M3.01172 8L12.2683 8" stroke="#292D32" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        <span class="pump-value">${'$' + item.price}</span>
                        <span class="pump-value percent">(${(item.rel_price_deviation > 0 ? '+' : '') + (item.rel_price_deviation * 100).toFixed(2)}%)</span>
                    </div>
                </div>
                <div class="live-card-section pump-volume-section">
                    <div class="pump-volume">
                        <div class="pump-label w-100">${window.pump.words['pumpVolume5m']}</div>
                        <div class="pump-value">${item.volume} (x${item.volume_spike_multiplier.toFixed(2)})</div>
                    </div>
                    <div class="pump-volume">
                        <div class="pump-label w-100">${window.pump.words['pumpVolume24h']}</div>
                        <div class="pump-value">${item.volume_24h} </div>
                    </div>
                </div>
            `;

            return card;
        }

        function getTargetColumn() {
            if (isMobile()) {
                return leftCol;
            }

            if (nextColumn === 'left') {
                nextColumn = 'right';
                return leftCol;
            }

            nextColumn = 'left';
            return rightCol;
        }

        function prependCardToColumn(item, column, isNew = true) {
            const card = createCard(item, isNew, false);

            column.prepend(card);

            // if (isNew) {
            //     setTimeout(() => {
            //         card.classList.remove('is-new');
            //     }, 500);
            // }

            const cards = column.querySelectorAll('.live-card');

            if (cards.length > 50) {
                const last = cards[cards.length - 1];
                last.remove();
            }

            return card;
        }

        function getFilteredTargetColumn() {
            if (isMobile()) {
                return leftCol;
            }

            const leftCount = leftCol.querySelectorAll('.live-card').length;
            const rightCount = rightCol.querySelectorAll('.live-card').length;

            if (leftCount < rightCount) {
                return leftCol;
            }

            if (rightCount < leftCount) {
                return rightCol;
            }

            const targetCol = filteredNextColumn === 'left' ? leftCol : rightCol;
            filteredNextColumn = filteredNextColumn === 'left' ? 'right' : 'left';

            return targetCol;
        }

        function prependCard(item, isNew = true) {
            const card = createCard(item, isNew, false);
            const targetCol = getTargetColumn();

            targetCol.prepend(card);

            if (isNew) {
                setTimeout(() => {
                    // card.classList.remove('is-new');

                    // удаляем последний элемент
                    const cards = targetCol.querySelectorAll('.live-card');

                    if (cards.length > 50) {
                        const last = cards[cards.length - 1];
                        last.remove();
                    }
                }, 500);
            }

            return card;
        }

        function getSkeletonsInRenderOrder() {
            const leftSkeletons = Array.from(leftCol.querySelectorAll('.live-card-skeleton'));

            if (isMobile()) {
                return leftSkeletons;
            }

            const rightSkeletons = Array.from(rightCol.querySelectorAll('.live-card-skeleton'));
            const result = [];
            const maxLength = Math.max(leftSkeletons.length, rightSkeletons.length);

            for (let i = 0; i < maxLength; i++) {
                if (leftSkeletons[i]) {
                    result.push(leftSkeletons[i]);
                }

                if (rightSkeletons[i]) {
                    result.push(rightSkeletons[i]);
                }
            }

            return result;
        }


        function replaceSkeletonsBatch() {
            const skeletons = getSkeletonsInRenderOrder();
            const items = [...allCards];

            resetColumnsState();

            items.forEach((item, index) => {
                const card = createCard(item, false, false);

                if (skeletons[index]) {
                    skeletons[index].replaceWith(card);
                } else {
                    const targetCol = getTargetColumn();
                    targetCol.append(card);
                }

            });

            skeletons.slice(items.length).forEach((skeleton) => {
                skeleton.remove();
            });

            liveCardsBlockHeight = liveCardsBlock.height()
        }

        function addLiveCard(item) {
            const result = upsertCard(item);

            if (isFilterActive()) {
                const data = getFormData();

                // если карточка не подходит под фильтр
                if (!cardMatchesFilters(item, data)) {
                    // если это обновление существующей карточки, надо перерисовать
                    if (!result.isNew) {
                        rerenderCards();
                    }
                    return;
                }

                // если это новая карточка — вставляем в менее заполненную колонку
                if (result.isNew) {
                    const targetCol = getFilteredTargetColumn();

                    prependCardToColumn(item, targetCol, true);
                    return;
                }

                // если это обновление существующей карточки — перерисовываем
                rerenderCards();
                return;
            }

            prependCard(item, true);
        }

        async function loadInitialHistory() {
            const historyRequest = window.cryptoAlertsHistory && window.cryptoAlertsHistory.pumpdumb
                ? window.cryptoAlertsHistory.pumpdumb
                : fetch('/wp-content/themes/crypto/sse/alerts-history.php?type=pumpdumb', {
                    cache: 'no-store',
                    credentials: 'same-origin'
                }).then((res) => res.json());

            let json;

            try {
                json = await historyRequest;
            } catch (error) {
                console.error('history load failed', error);
                return;
            }

            if (!json.ok) {
                console.error('history load failed', json);
                return;
            }

            const historyItems = Array.isArray(json.items) ? json.items : [];
            const items = historyItems.map(item => {
                return {
                    ...JSON.parse(item.fields.payload),
                    id: item.id
                };
            });

            allCards = [...items];
            replaceSkeletonsBatch();
            return {
                lastHistoryId: historyItems[0]?.id || '0-0',
                partial: json.partial === true
            };
        }

        function isNewerStreamId(id, referenceId) {
            const [time, sequence] = String(id || '').split('-').map(Number);
            const [referenceTime, referenceSequence] = String(referenceId || '').split('-').map(Number);
            return time > referenceTime || (time === referenceTime && sequence > referenceSequence);
        }

        async function loadRemainingHistory(retryDelay = 5000) {
            try {
                const response = await fetch('/wp-content/themes/crypto/sse/alerts-history.php?type=pumpdumb', {
                    cache: 'no-store',
                    credentials: 'same-origin'
                });

                if (!response.ok) throw new Error(`History request failed: ${response.status}`);

                const json = await response.json();

                if (!json.ok || !Array.isArray(json.items)) throw new Error('Invalid history response');

                const items = json.items.map(item => ({
                    ...JSON.parse(item.fields.payload),
                    id: item.id
                }));
                const newestHistoryId = json.items[0]?.id;
                const liveItems = newestHistoryId
                    ? allCards.filter(item => isNewerStreamId(item.id, newestHistoryId))
                    : [];

                allCards = [...liveItems, ...items].slice(0, 100);
                rerenderCards();
            } catch (error) {
                console.error('full history load failed', error);
                setTimeout(() => loadRemainingHistory(Math.min(retryDelay * 2, 30000)), retryDelay);
            }
        }

        function startSse(lastHistoryId) {
            const since = lastHistoryId ? `&since=${encodeURIComponent(lastHistoryId)}` : '';
            const sse = new EventSource(`/wp-content/themes/crypto/sse/alerts.php?type=pumpdumb${since}`);

            sse.onopen = () => {
                console.log('SSE open');
            };

            sse.onerror = (e) => {
                console.log('SSE reconnecting...', sse.readyState, e);
            };

            sse.addEventListener('connected', (e) => {
                console.log('connected', JSON.parse(e.data));
            });

            sse.addEventListener('ping', (e) => {
                console.log('ping', JSON.parse(e.data));
            });

            sse.addEventListener('redis_message', (e) => {
                if(!allCards.length) {
                    replaceSkeletonsBatch();
                }

                const json = JSON.parse(e.data);
                const payload = {
                    ...JSON.parse(json.fields.payload),
                    id: json.id
                };

                addLiveCard(payload);
            });

            sse.addEventListener('server_error', (e) => {
                console.log('server_error', JSON.parse(e.data));
            });

            return sse;
        }

        (async function initAlerts() {
            const initialHistory = await loadInitialHistory();
            startSse(initialHistory?.lastHistoryId);

            if (initialHistory?.partial) {
                requestAnimationFrame(() => setTimeout(loadRemainingHistory, 0));
            }
        })();



        // function getUtcNowMicro() {
        //     const now = new Date();
        //
        //     const iso = now.toISOString(); // 2026-03-18T09:53:06.377Z
        //
        //     const [datePart, msPart] = iso.split('.'); // ["2026-03-18T09:53:06", "377Z"]
        //
        //     const ms = msPart.replace('Z', ''); // "377"
        //
        //     const micro = (ms + '000').padEnd(6, '0'); // "377000"
        //
        //     return `${datePart}.${micro}Z`;
        // }


        // setTimeout(() => {
        //     let i = 1;
        //     setInterval(() => {
        //         addLiveCard({
        //             "symbol": `${i}`,
        //             "buy_exchange": "mexc",
        //             "sell_exchange": "kucoin",
        //             "buy_price": 4155.22,
        //             "sell_price": 4268.74,
        //             "spread_pct": Math.random() * (10 - 0.1) + 0.1,
        //             "estimated_profit_pct": 2.4237893541136097,
        //             "alert_type": "arbitrage",
        //             "timestamp": getUtcNowMicro(),
        //             "time": "2026-03-18T09:53:06.377432Z",
        //             "sell_exchange_link": "https://www.kucoin.com/r/af/CXEJS1N1",
        //             "buy_exchange_link": "https://promote.mexc.com/a/E9rANhqJ"
        //         });
        //         i++
        //     }, 2000)
        // }, 3000);

        //Бегаем по новым и снимаем подсветку, если старше 2 минут
        setInterval(() => {
            const now = Date.now();

            document.querySelectorAll('.live-card.is-new').forEach(card => {
                let timestamp = card.dataset.timestamp;

                if (!timestamp) return;

                // фикс для микросекунд (если есть)
                timestamp = timestamp.replace(/\.(\d{3})\d+Z$/, '.$1Z');

                const time = new Date(timestamp).getTime();

                if (!time) return;

                if (now - time >= 2 * 60 * 1000) {
                    card.classList.remove('is-new');
                }
            });

        }, 1000);
        //
        //
        // // SSE TEST
        // const sse = new EventSource('/wp-content/themes/crypto/sse/alerts.php?type=arbitrage')
        //
        // sse.onopen = () => {
        //     // console.log('SSE open')
        // }
        //
        // sse.onerror = (e) => {
        //     console.log('SSE reconnecting...', sse.readyState, e)
        // }
        //
        // sse.addEventListener('connected', (e) => {
        //     // console.log('connected', JSON.parse(e.data))
        // })
        //
        // sse.addEventListener('ping', (e) => {
        //     // console.log('ping', JSON.parse(e.data))
        // })
        //
        // sse.addEventListener('redis_history', (e) => {
        //     // console.log('redis_history', JSON.parse(e.data))
        //     const json = JSON.parse(e.data);
        //     const items = json.items.map(item => {
        //         return {...JSON.parse(item.fields.payload), id: item.id};
        //     })
        //
        //     allCards = [...items];
        //
        //     replaceSkeletonsBatch();
        // })
        //
        // sse.addEventListener('redis_message', (e) => {
        //     // console.log('redis_message', JSON.parse(e.data))
        //     const json = JSON.parse(e.data);
        //     const payload = {
        //         ...JSON.parse(json.fields.payload),
        //         id: json.id
        //     };
        //
        //     addLiveCard(payload)
        // })
        //
        //
        // sse.addEventListener('server_error', (e) => {
        //     console.log('server_error', JSON.parse(e.data))
        // })
    });
}(jQuery));
